
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function CheckIcon(props) {
    const { style } = props;
    const classes = useStyles(props)()

    return(
        <div style={{position:"relative", display:"flex", justifyContent:"center", alignItems:"center", width:"100%"}}>
            <svg className={classes.container}  style={style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="18" height="18" rx="5" stroke="#192A7F" strokeWidth="2"/>
            </svg>
            <svg style={{position:"absolute"}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="10" height="10" rx="3" fill="#2196C0"/>
            </svg>
        </div>
    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));